import script from "./PartnerProjectAgreement.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerProjectAgreement.vue?vue&type=script&setup=true&lang=js"

import "./PartnerProjectAgreement.vue?vue&type=style&index=0&id=7a593d5a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a593d5a"]])

export default __exports__